import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractLongFormInstructionsFromPdf($projectId: ID, $sectionId: ID!, $documentId: ID!) {
    extractLongFormInstructionsFromPdf(
      projectId: $projectId
      sectionId: $sectionId
      documentId: $documentId
    ) {
      instructions
      status
      extractionErrors
    }
  }
`;

export const extractLongFormInstructionsFromPdf = ({ projectId, sectionId, documentId }) => {
  const variables = { projectId, sectionId, documentId };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
